import { useI18n } from '@ecom/i18n';
import { type ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { ManualEntryForm, type ManualEntryKind } from '../components/ManualEntryForm';

/** « Ajouter une commande » (`/orders/new`) and « Ajouter une vente » (`/sales/new`) — migration 0096. */
export function ManualEntryPage({ kind }: { kind: ManualEntryKind }): ReactElement {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <div>
        <Link
          to={kind === 'sale' ? '/sales' : '/orders'}
          className="text-sm text-inkSoft underline-offset-2 hover:underline"
        >
          {t(kind === 'sale' ? 'merchant.manual.backToSales' : 'merchant.manual.backToOrders')}
        </Link>
        <h1 className="mt-1 font-display text-2xl font-bold text-ink">
          {t(kind === 'sale' ? 'merchant.manual.newSaleTitle' : 'merchant.manual.newOrderTitle')}
        </h1>
        <p className="text-sm text-inkFaint">
          {t(
            kind === 'sale'
              ? 'merchant.manual.newSaleSubtitle'
              : 'merchant.manual.newOrderSubtitle',
          )}
        </p>
      </div>
      <ManualEntryForm kind={kind} />
    </div>
  );
}
